import React from "react";
import QrReader from "react-qr-reader";
import { Icon, Modal } from "@weezevent/nacre";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

/**
 * Modal window for scanning QR code via camera.
 */
const QRCodeScanModal = ({ title, onScan, isOpen, onClose }) => {
	const { t } = useTranslation();
	const [mode, setMode] = React.useState("environment");

	const handleQRDetected = data => {
		if (data) {
			onScan(data);
			onClose();
		}
	};

	return (
		<Modal
			className="modal-qr-reader"
			title={t("access.exploitation.searchWithQR")}
			open={isOpen}
			onClose={onClose}
		>
			<QrReader
				delay={300}
				facingMode={mode}
				onError={onClose}
				onScan={handleQRDetected}
				style={{ width: "100%" }}
			/>
			<div
				className="switch-camera"
				onClick={() =>
					setMode(mode === "user" ? "environment" : "user")
				}
			>
				<Icon name="mobile-alt" />
				{t("access.exploitation.labelModeCamera")}
			</div>
		</Modal>
	);
};

QRCodeScanModal.propTypes = {
	/**
	 * Title of the modal.
	 */
	title: PropTypes.string.isRequired,

	/**
	 * Function called when the QR code is scanned.
	 */
	onScan: PropTypes.func,

	/**
	 * Whether the modal is open.
	 */
	isOpen: PropTypes.bool,

	/**
	 * Function called when the modal is closed.
	 */
	onClose: PropTypes.func
};

QRCodeScanModal.defaultProps = {
	onScan: () => {},
	onError: () => {},
	onClose: () => {},
	isOpen: false
};

export default QRCodeScanModal;
